/**
 * Returns a new object which contains a subset of properties from another object.
 * @param obj - The original object
 * @param paths - An array of properties to pick from 'obj'
 */
export function pick<T, U extends keyof T>(obj: T, paths: Array<U>): Pick<T, U> {
    return paths.reduce((o, k) => {
        o[k] = obj[k];
        return o;
    }, Object.create(null));
}

/**
 * Returns a new array which contains a subset of property values from another object.
 * @param obj - The original object
 * @param paths - An array of properties to pick from 'obj'
 */
export function pickArray<T, U extends keyof T>(obj: T, paths: Array<U>): Array<unknown> {
    return paths.map<unknown>((value) => obj[value]);
}
